import config from '../../config';
import { OktaAuth } from '@okta/okta-auth-js';

const oktaAuth = new OktaAuth(config.okta);
oktaAuth.start();
class AuthProvider {
  init() {
    return new Promise((resolve, reject) => {
      if (oktaAuth.token.isLoginRedirect()) {
        oktaAuth.token
          .parseFromUrl()
          .then((result) => {
            oktaAuth.tokenManager.setTokens(result.tokens);
            const token = result.tokens.accessToken;
            this.state = {
              isInitialized: true,
              isAuthenticated: true,
              accessToken: token.accessToken,
              // Jitto's embedded dashboards take the user's ID token (ANS-678): its
              // audience is this app and its subject is the Okta user id.
              idToken: result.tokens.idToken ? result.tokens.idToken.idToken : undefined,
              uid: token.claims.uid,
              username: token.claims.sub,
            };
            resolve({ path: result.state });
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      } else {
        this.state = {
          isInitialized: true,
          isAuthenticated: false,
        };
        setTimeout(() => resolve({}), 10);
      }
    });
  }

  login(path) {
    oktaAuth.token.getWithRedirect({
      state: path ? path : '/',
      scopes: ['openid', 'email', 'groups'],
    });
  }

  logout() {
    oktaAuth
      .revokeAccessToken()
      .then(() => oktaAuth.signOut())
      .then(() => {
        oktaAuth.tokenManager.clear();
      });
  }

  getState() {
    return { ...this.state };
  }
}

const authProvider = new AuthProvider();

// The token manager renews the tokens in the background. Keep the copies authFetch
// and getJittoEmbedToken send in step, or every call is refused once the first expires.
oktaAuth.tokenManager.on('renewed', (key, token) => {
  if (!authProvider.state || !token) return;
  if (key === 'accessToken' && token.accessToken) {
    authProvider.state = { ...authProvider.state, accessToken: token.accessToken };
  }
  if (key === 'idToken' && token.idToken) {
    authProvider.state = { ...authProvider.state, idToken: token.idToken };
  }
});

export default authProvider;
